module.exports = __webpack_public_path__ + "static/soporte-4ed089da48a5040c260b53070c69992f.svg";